import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Me } from '../models/me';

@Injectable
({
    providedIn: 'root'
})
export class MeService
{
    private http = inject(HttpClient);

    readonly BASE_URL = '/api/me';

    get(): Observable<Me>
    {
        const url = `${this.BASE_URL}`;
        return this.http.get<Me>(url);
    }

    update(
        body: {
            avatar_url?: string;
            first_name?: string;
            last_name?: string;
        }
    ): Observable<Me>
    {
        const url = `${this.BASE_URL}`;
        return this.http.patch<Me>(url, body);
    }
}
